module.exports = __webpack_public_path__ + "static/img/baselineRepair_pic04.c3faefa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/baselineRepair/baselineRepair_pic04.png
// module id = 469
// module chunks = 1